/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnnotationCursor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8.376 2.756a8.691 8.691 0 0 0-2.967 2.13 8.485 8.485 0 0 0-1.968 5.892c.117 2.128 1.043 4.141 2.603 5.661l3.902 3.736L12 22l2.51-2.261 3.45-3.304c1.558-1.52 2.483-3.533 2.599-5.66a8.485 8.485 0 0 0-1.968-5.889c-.818-.906-1.83-1.632-2.967-2.13S13.25 2 12 2a9.04 9.04 0 0 0-3.624.756z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAnnotationCursor as AnnotationCursor };
